import React from 'react';
import './css/share-code.css';
import bj from './image/bj1.png';

document.title = '老板悄悄话';

const Menu1 = () => <div className="menuBackground"><img src={bj} alt="bj1" /></div>;

export default Menu1;
